import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@app/auth/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard {

  constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService,
  ) {}

  async canActivate(): Promise<boolean> {
    const isLoggedIn = await this.authenticationService.validateLogin();

    if (isLoggedIn) {
      await this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
